import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { JobsService } from '../standard';

@Injectable()
export class JobGuard  {
	constructor(private jobsService: JobsService, private router: Router) {
	}

	canActivate(
			next: ActivatedRouteSnapshot,
			state: RouterStateSnapshot): boolean {
		if (this.jobsService.selectedJobCurrent) {
			return true;
		} else {
			this.router.navigate(['home', 'jobs']);
			return false;
		}
	}
}
